import { Heading, Grid } from '@design-systems/canvas-ui'
import { useEssentials } from 'hooks/utils/useEssentials'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { getInsightIcon } from '../utils'
import type { InsightDetailsHeaderProps } from './types'

export const InsightDetailsHeader = ({
    title,
    iconKey,
    datePrefix,
    dateLabel,
    whatChanged,
    whyItMatters,
}: InsightDetailsHeaderProps) => {
    const { t } = useEssentials()
    const { details } = TRANSLATION_KEYS.insights

    return (
        <Grid.Container direction="column" noWrap>
            <Grid.Item>
                <p className="hc8-clr-base hc8-fs-050 hc8-mb-2x">
                    {`${datePrefix} \u00b7 ${dateLabel}`}
                </p>
            </Grid.Item>
            <Grid.Item>
                <Grid.Container
                    direction="row"
                    noWrap
                    spacing="none"
                    align="flex-start"
                >
                    <Grid.Item
                        size={{ xs: 3 }}
                        className="insight-details__icon"
                    >
                        <img src={getInsightIcon(iconKey)} alt="" />
                    </Grid.Item>
                    <Grid.Item size={{ xs: 9 }}>
                        <Heading size={3} className="hc8-clr-base">
                            {title}
                        </Heading>
                    </Grid.Item>
                </Grid.Container>
            </Grid.Item>
            <Grid.Item>
                {whatChanged.length > 0 && (
                    <section className="hc8-mb-4x">
                        <h2 className="hc8-clr-base hc8-fs-250 hc8-mb-1x">
                            <strong>{t(details.whatChanged)}</strong>
                        </h2>
                        <ul className="hc8-clr-base hc8-fs-050 hc8-ma-none hc8-pl-4x">
                            {whatChanged.map((item) => (
                                <li
                                    key={item}
                                    className="hc8-lh-body hc8-mb-2x"
                                >
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </section>
                )}
            </Grid.Item>
            <Grid.Item>
                {whyItMatters && (
                    <section className="hc8-mb-4x">
                        <h2 className="hc8-clr-base hc8-fs-250 hc8-mb-1x">
                            <strong>{t(details.whyItMatters)}</strong>
                        </h2>
                        <p className="hc8-clr-base hc8-fs-050 hc8-ma-none hc8-lh-body">
                            {whyItMatters}
                        </p>
                    </section>
                )}
            </Grid.Item>
        </Grid.Container>
    )
}
